var map = {
	"./apple-store.jpg": "ab90",
	"./camera.jpg": "a566",
	"./cover.jpg": "9956",
	"./google-play.jpg": "4750",
	"./logo.jpg": "b640",
	"./user.jpg": "18d5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "416a";